import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Alert, Spinner, Row, Col, FormGroup } from "reactstrap";

import {
  Container,
  InputAuth,
  Form,
  ButtonAuth,
  InstructionText,
  EyeIcon,
  ProgressBar,
  ProgressBarWrapper,
} from "./styles";
import { faKey, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cookie from "../../services/cookie";
import { useLocation } from "react-router-dom";
import api from "../../services/client/api";

const ReplacePassView = () => {
  const history = useHistory();
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [error, setError] = useState("");
  const [inProgress, setInProgress] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const location = useLocation();
  const { username, id } = location.state || {};

  useEffect(() => {
    if (!username && !id) {
      history.replace("/login");
    }
  }, [username, id, history]);

  const calculateStrength = (password) => {
    let strength = 0;

    const lengthCriteria = password.length >= 8;
    const specialCharCriteria = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    const upperLowerCaseCriteria =
      /[a-z]/.test(password) && /[A-Z]/.test(password);
    const numberCriteria = /[0-9]/.test(password);

    if (lengthCriteria) strength += 25;
    if (specialCharCriteria) strength += 25;
    if (upperLowerCaseCriteria) strength += 25;
    if (numberCriteria) strength += 25;

    return strength;
  };

  const [strength, setStrength] = useState(0);

  useEffect(() => {
    const currentStrength = calculateStrength(password);
    setStrength(currentStrength);

    // Verifique se todos os critérios foram atendidos
  }, [password, passwordConfirmation]);

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (password !== passwordConfirmation) {
      setError("As senhas não correspondem.");
      return;
    }

    if (password.length < 8) {
      setError("A senha deve conter no mínimo 8 caracteres.");
      setInProgress(false);
      return;
    }

    if (!/[A-Z]/.test(password)) {
      setError("A senha deve conter pelo menos uma letra maiúscula.");
      setInProgress(false);
      return;
    }

    if (!/[a-z]/.test(password)) {
      setError("A senha deve conter pelo menos uma letra minúscula.");
      setInProgress(false);
      return;
    }

    if (!/[0-9]/.test(password)) {
      setError("A senha deve conter pelo menos um número.");
      setInProgress(false);
      return;
    }

    if (!/[!@#$%^&*(),.?":{}|<>_\-+=~`[\]\\;]/.test(password)) {
      setError(
        "A senha deve conter pelo menos um caractere especial (@, $, #...).",
      );
      setInProgress(false);
      return;
    }

    let statusCode;
    setInProgress(true);
    setError("");

    try {
      const response = await api().user().updatePass({
        id,
        password,
        passwordConfirmation,
      });

      statusCode = response.status;

      if (statusCode !== 200) {
        setError(
          response.message ||
            "Ocorreu um erro ao salvar a nova senha. Atualize a página e tente novamente.",
        );
        return;
      }

      cookie().set("token", response.output.token, 30 / 1440);
      cookie().set("username", response.output.user.username, 30 / 1440);
      cookie().set("role", response.output.user.role, 30 / 1440);
      cookie().set("name", response.output.user.name, 30 / 1440);
      history.replace({
        pathname: "/",
      });
      return;
    } catch (err) {
      setError(
        "Ocorreu um erro ao salvar a senha. Atualize a página e tente novamente.",
      );
      return;
    } finally {
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleChangePassword(e);
    }
  };

  return (
    <Container>
      <Form onSubmit={handleChangePassword}>
        <h3>Crie uma senha</h3>

        <Row>
          <Col xs="12">
            <FormGroup>
              <div style={{ position: "relative" }}>
                <InputAuth
                  type={showPassword ? "text" : "password"}
                  placeholder="Digite a nova senha"
                  value={password}
                  maxLength="64"
                  onChange={(e) => setPassword(e.target.value)}
                  onKeyPress={handleKeyPress}
                  required
                />
                <EyeIcon onClick={() => setShowPassword(!showPassword)}>
                  <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                </EyeIcon>
              </div>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs="12">
            <FormGroup>
              <div style={{ position: "relative" }}>
                <InputAuth
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder="Confirme a senha"
                  value={passwordConfirmation}
                  maxLength="64"
                  onChange={(e) => setPasswordConfirmation(e.target.value)}
                  onKeyPress={handleKeyPress}
                  required
                />
                <EyeIcon
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  <FontAwesomeIcon
                    icon={showConfirmPassword ? faEyeSlash : faEye}
                  />
                </EyeIcon>
              </div>
              <ProgressBarWrapper>
                <ProgressBar strength={strength} />
              </ProgressBarWrapper>

              {/*  {strength > 25 && strength < 100 && (
                            <p style={{ color: 'red' }}></p>
                            )} */}

              {strength === 100 && (
                <p style={{ color: "green" }}>Senha válida</p>
              )}
            </FormGroup>
          </Col>
        </Row>
        <InstructionText>
          Escolha uma senha forte utilizando:
          <ul>
            <li>A senha deve conter no mínimo 8 caracteres</li>
            <li>Caracteres especiais (@, $, #...)</li>
            <li>Letras maiúsculas e minúsculas (A, a)</li>
            <li>Números e letras (a123)</li>
          </ul>
        </InstructionText>

        <Row>
          <Col>
            <ButtonAuth
              color="primary"
              type="submit"
              onClick={handleChangePassword}
              disabled={inProgress}
            >
              {inProgress ? <Spinner size="sm" /> : "Salvar senha"}
              <FontAwesomeIcon icon={faKey} style={{ marginLeft: "12px" }} />
            </ButtonAuth>
            {error && <Alert color="danger">{error}</Alert>}
          </Col>
        </Row>
      </Form>
    </Container>
  );
};

export default ReplacePassView;
